import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { AbstractInputDirective } from '../AbstractInputDirective';
import { FormControl, FormGroup } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { DateUtil } from '../../DateUtil';
import moment from 'moment';
import { ReportMonth } from '../../model/ReportMonth';

@Component({
  selector: 'digires-month-input',
  templateUrl: './month-input.component.html',
  styleUrls: ['./month-input.component.scss'],
})
export class MonthInputComponent extends AbstractInputDirective implements OnInit, OnChanges, OnDestroy {
  readonly destroy$: Subject<boolean> = new Subject<boolean>();

  @Input() min: ReportMonth = ReportMonth.of(1, 2000);
  @Input() max: ReportMonth = ReportMonth.of(1, 2999);
  minStr: string;
  maxStr: string;
  internalFormGroup: FormGroup;
  isPatchingFg: boolean = false;

  override ngOnInit(): void {
    super.ngOnInit();
    this.internalFormGroup = new FormGroup({value: new FormControl(moment())});
    this.getCtrl()
      .valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(newValue => {
        if (!this.isPatchingFg) {
          this.syncExternalToInternalFormGroups(newValue);
        }
      });
    this.syncExternalToInternalFormGroups(this.getValue());
  }

  override ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);
    this.minStr = ReportMonth.yyyy_mm(this.min);
    this.maxStr = ReportMonth.yyyy_mm(this.max);
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  override onInputChanged(): void {
    this.syncInternalToExternalFormGroups(this.internalFormGroup.value.value);
    super.onInputChanged();
  }

  private syncInternalToExternalFormGroups(newInternalValue: any) {
    this.isPatchingFg = true;
    const newExternalValue = DateUtil.formField(DateUtil.yyyymmToDate(newInternalValue));
    this.patch(newExternalValue);
    this.isPatchingFg = false;
  }

  private syncExternalToInternalFormGroups(newExternalValue: any) {
    this.isPatchingFg = true;
    const newInternalValue = DateUtil.yyyymmFormField(DateUtil.yyyymmddToDate(newExternalValue));
    this.internalFormGroup.patchValue({value: newInternalValue});
    this.isPatchingFg = false;
  }

}
